<mat-dialog-content class="task-detail-content">
    <h2 mat-dialog-title>{{ data.task.name }}</h2>

    <div class="estimated-time" *ngIf="data.task.estimatedTime">
        <h3>Tiempo estimado:</h3>
        <p>{{ data.task.estimatedTime }}</p>
    </div>
    
    <div>
      <p>{{ data.task.description }}</p>
    </div>

    <mat-vertical-stepper [linear]="false" #stepper *ngIf="data.premiumMode">
      <mat-step *ngFor="let step of data.task.steps; let i = index" [stepControl]="formGroups[i]">
        <form [formGroup]="formGroups[i]">
          <ng-template matStepLabel>{{ step.label }}</ng-template>
          <p>{{ step.description }}</p>
          <div>
            <button mat-button matStepperNext *ngIf="showNext(i,data)">Siguiente</button>
            <button mat-button matStepperPrevious *ngIf="i > 0">Atrás</button>
          </div>
        </form>
      </mat-step>
    </mat-vertical-stepper>
    
    <mat-vertical-stepper [linear]="false" #stepper *ngIf="!data.premiumMode">
      <mat-step *ngFor="let step of data.task.services; let i = index" [stepControl]="formGroups[i]">
        <form [formGroup]="formGroups[i]">
          <ng-template matStepLabel>{{ step.label }}</ng-template>
          <p>{{ step.description }}</p>
          <div>
            <button mat-button matStepperNext *ngIf="showNext(i,data)">Siguiente</button>
            <button mat-button matStepperPrevious *ngIf="i > 0">Atrás</button>
          </div>
        </form>
      </mat-step>
    </mat-vertical-stepper><mat-vertical-stepper [linear]="false" #stepper *ngIf="data.premiumMode">
      <mat-step *ngFor="let step of data.task.steps; let i = index" [stepControl]="formGroups[i]">
        <form [formGroup]="formGroups[i]">
          <ng-template matStepLabel>{{ step.label }}</ng-template>
          <p>{{ step.description }}</p>
          <div>
            <button mat-button matStepperNext *ngIf="showNext(i,data)">Siguiente</button>
            <button mat-button matStepperPrevious *ngIf="i > 0">Atrás</button>
          </div>
        </form>
      </mat-step>
    </mat-vertical-stepper>

    <div class="task-location" *ngIf="data.task.location">
      <h3>¿Cómo llegar?</h3>
      <!-- Add your location display logic here -->
    </div>
  
    <div class="more-info" *ngIf="data.task.moreInfo.length>0">
      <h3>Más información</h3>
      <p>{{ data.moreInfo }}</p>
    </div>

    <div *ngIf="askQuestionFlag">
      <h3>Escribe tu pregunta y te contestaremos en breve.</h3>
      <div class="col-md-12"> <label id="firstname"></label>
        <textarea type="text" class="form-control" placeholder="Duda o pregunta"></textarea> <!-- [(ngModel)]="getCotizacionData().data" -->
      </div>
    </div>
    
  </mat-dialog-content>
  
  <mat-dialog-actions class="dialog-actions">
    <button mat-button color="primary" (click)="askQuestion()">Tengo una duda</button>
    <button mat-button color="accent" (click)="onNoClick()">Ok</button>
  </mat-dialog-actions>
